import {
  ApolloClient,
  InMemoryCache,
  gql,
  concat,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

// API хаяг — instance.js-тэй ижил REACT_APP_API_URL хувьсагчийг ашиглана.
// Локал: .env.local дотор REACT_APP_API_URL=http://192.168.1.100:4000
const API_URL = process.env.REACT_APP_API_URL || "https://api.erdenet24.mn";

// HTTP link
const httpLink = createHttpLink({ uri: `${API_URL}/graphql` });

// Auth header нэмэх
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

// Apollo Client тохиргоо
export const client = new ApolloClient({
  link: concat(authLink, httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});

// ==== GRAPHQL QUERIES / MUTATIONS ====

export const GET_MERCHANT_PRODUCTS = gql`
  query ($limit: Int, $offset: Int) {
    data: getProducts(limit: $limit, offset: $offset) {
      id
      name
      image
      price
      quantity
      isVisible
    }
    totalCount: countProducts
  }
`;

export const GET_ORDERS = gql`
  query (
    $statusIds: [Int]
    $limit: Int
    $offset: Int
    $startDate: String
    $endDate: String
  ) {
    data: getMerchantOrders(
      statusIds: $statusIds
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      orderCode
      deliveryPrice
      totalAmount
      prepDuration
      address
      phone
      code
      district {
        name
      }
      statusHistory {
        id
        orderId
        statusId
        changedAt
        status {
          id
          name
        }
      }
      products {
        id
        productName
        productImage
        productPrice
        quantity
      }
      status {
        id
        name
        updatedAt
      }
      merchant {
        id
        name
        image
      }
      updatedAt
      createdAt
    }
    totalCount: getMerchantOrdersCount(
      statusIds: $statusIds
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

export const PASSWORD_LOGIN = gql`
  mutation ($loginName: String!, $loginPassword: String!, $role: String!) {
    data: handlePasswordLogin(
      loginName: $loginName
      loginPassword: $loginPassword
      role: $role
    ) {
      success
      message
      data {
        id
        token
        name
        phone
        duration
        isOpen
      }
    }
  }
`;

export const UPDATE_ORDER_STATUS = gql`
  mutation updateOrderStatus($input: OrderInput!) {
    updateOrderStatus(input: $input) {
      id
    }
  }
`;

export const UPDAT_MERCHANT_INFO = gql`
  mutation ($input: MerchantInput!) {
    updateMerchant(input: $input) {
      success
      message
    }
  }
`;

export const UPDAT_PRODUCT_INFO = gql`
  mutation ($input: ProductInput!) {
    updateProduct(input: $input) {
      success
      message
    }
  }
`;
